import yunxinIM from './yunxinIM.js'
import { MESSAGE_TYPE } from './enums.js'

const RTC_PUSH_TEXT = {
	[MESSAGE_TYPE.RTC_SETUP_VOICE]: '邀请你进行语音通话',
	[MESSAGE_TYPE.RTC_SETUP_VIDEO]: '邀请你进行视频通话'
}

class RtcPrivateApi {
	send(uid, type, content = '') {
		const payload = {
			type,
			content: typeof content === 'string' ? content : JSON.stringify(content),
			sendId: yunxinIM.currentAccount,
			recvId: String(uid),
			timestamp: Date.now()
		}
		return yunxinIM.sendP2PCustomNotification(String(uid), payload, {
			notificationConfig: {
				offlineEnabled: true,
				unreadEnabled: false,
				clientNotificationId: `${type}_${Date.now()}`
			},
			pushConfig: {
				pushEnabled: true,
				pushNickEnabled: true,
				pushContent: RTC_PUSH_TEXT[type] || '音视频通话状态更新',
				forcePush: false,
				forcePushAccountIds: []
			}
		})
	}
}

RtcPrivateApi.prototype.setup = function (uid, mode) {
	return this.send(uid, mode === 'voice' ? MESSAGE_TYPE.RTC_SETUP_VOICE : MESSAGE_TYPE.RTC_SETUP_VIDEO)
}

RtcPrivateApi.prototype.accept = function (uid) {
	return this.send(uid, MESSAGE_TYPE.RTC_ACCEPT)
}

RtcPrivateApi.prototype.handup = function (uid) {
	return this.send(uid, MESSAGE_TYPE.RTC_HANDUP)
}

RtcPrivateApi.prototype.cancel = function (uid) {
	return this.send(uid, MESSAGE_TYPE.RTC_CANCEL)
}

RtcPrivateApi.prototype.reject = function (uid) {
	return this.send(uid, MESSAGE_TYPE.RTC_REJECT)
}

RtcPrivateApi.prototype.failed = function (uid, reason) {
	return this.send(uid, MESSAGE_TYPE.RTC_FAILED, reason)
}

RtcPrivateApi.prototype.offer = function (uid, offer) {
	return this.send(uid, MESSAGE_TYPE.RTC_OFFER, offer)
}

RtcPrivateApi.prototype.answer = function (uid, answer) {
	return this.send(uid, MESSAGE_TYPE.RTC_ANSWER, answer)
}

RtcPrivateApi.prototype.sendCandidate = function (uid, candidate) {
	return this.send(uid, MESSAGE_TYPE.RTC_CANDIDATE, candidate)
}

RtcPrivateApi.prototype.heartbeat = function (uid) {
	return Promise.resolve(uid)
}

export default RtcPrivateApi
